import { createStyles, makeStyles } from "@material-ui/core";
import { COLORS } from "config/theme/baseTheme";

export const useStyles = makeStyles(() =>
  createStyles({
    root: {
      flexGrow: 1,
      marginLeft: 24,
      marginRight: 24,
    },
    pageTitle: {
      padding: "16px 16px 0 0",
      fontSize: 20,
    },
    statusHeader: {
      "& .statusMsgMore": {
        fontWeight: "bold",
      },
    },
    customFilter: {
      display: "flex",
       alignItems: "center",
       padding: "4px 8px",
       borderRadius: "38px",
       backgroundColor: "#F7F8F9", // Static gray background for the badge
       fontWeight: "bold",
       textAlign: "center",
       border: '1px solid #EBF0F5',
       marginLeft:8

    },
    carrierSwitchingIcon: {
      marginLeft: '4px'
    }
  })
);
